import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  links: [],
  loading: false,
  error: false,
};

const auditUserOptions = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.AUDIT_DAILY_RECEIPT_REPORT_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case actionTypes.AUDIT_DAILY_RECEIPT_REPORT_SUCCESS:
      return {
        ...state,
        links: [...payload],
        loading: false,
      };
    case actionTypes.AUDIT_DAILY_RECEIPT_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case actionTypes.AUDIT_DAILY_TOTALS_REPORT_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case actionTypes.AUDIT_DAILY_TOTALS_REPORT_SUCCESS:
      return {
        ...state,
        links: [...payload],
        loading: false,
      };
    case actionTypes.AUDIT_DAILY_TOTALS_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case actionTypes.AUDIT_DAILY_REPORT_CLEAR:
      return {
        ...INITIAL_STATE,
      };

    default:
      return state;
  }
};

export default auditUserOptions;
